import React from "react";
import { Container, Row } from "../components";
import { Content } from "./content";
import { Spacer } from "./spacer";
import { Text } from "./text";

interface PartnerPortalFooterProps {
  portalHelpEmail: string;
}

export function PartnerPortalFooter(props: PartnerPortalFooterProps) {
  const { portalHelpEmail } = props;

  return (
    <div className="partner-portal-expand-footer">
      <Content>
        <Container paddingHorizontal={16}>
          <Text size="sm" color="white">
            Need help? Email{" "}
            <FooterLink underline href={`mailto:${portalHelpEmail}`}>
              {portalHelpEmail}
            </FooterLink>
          </Text>
          <div className="partner-portal-footer-powered">
            <Text color="muted">
              <FooterLink size="xs">Powered by Flexspace&reg;</FooterLink>
            </Text>
            <Row>
              <FooterLink
                size="xs"
                href="https://meet-production.s3-us-west-1.amazonaws.com/documents/flexspace-privacy.pdf"
              >
                Privacy
              </FooterLink>
              <Spacer size={8} direction="horizontal" />
              <Text size="xs" color="white">
                ·
              </Text>
              <Spacer size={8} direction="horizontal" />
              <FooterLink
                size="xs"
                href="https://meet-production.s3-us-west-1.amazonaws.com/documents/flexspace-terms.pdf"
              >
                Terms
              </FooterLink>
            </Row>
          </div>
        </Container>
      </Content>
    </div>
  );
}

interface FooterLinkProps {
  href?: string;
  children: React.ReactText;
  size?: "md" | "sm" | "xs";
  underline?: boolean;
}

function FooterLink(props: FooterLinkProps) {
  const { href, children, size, underline } = props;

  return (
    <a
      href={href}
      style={{
        fontFamily: "Helvetica",
        color: "white",
        textDecoration: underline ? "underline" : "none",
      }}
      className={size && `text-size-${size}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}
